module.exports = __webpack_public_path__ + "media/images/workplace/activity_points/badges_png/reward_badge_gold-a6df753c5cb7705535be73e99c41676c.png";